import { Dealer } from "../../dealer/shared/dealer.model";
import { KnownUser } from "../../user/known-user.model";

export class DealerRep extends KnownUser {

    public static override stringifyExclude: string[] = [
        "_dealer_id",
        "_dealer",
        "_user_roles"
    ];

    private _dealer_id: number = -1;
    private _dealer: Dealer | null | undefined;

    public get dealer_id(): number {
        return this._dealer_id;
    }

    public set dealer_id(value: number) {
        this._dealer_id = value;
    }

    public get dealer(): Dealer | null | undefined {
        return this._dealer;
    }

    public set dealer(value: Dealer) {
        this._dealer = value;
    }

    // This function, when present, is automatically
    // called by the JSON.stringify function.
    public override toJSON() {
        return super.toJSON(DealerRep.stringifyExclude);
    }

    public static toDealerReps(obj: string | Object[]): DealerRep[] {
        let obj2 = obj;

        // If not string, then assumption is an
        // array of objects.
        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let dealerReps: DealerRep[] = [];

        for (const o2 of (<Object[]>obj2)) {
            dealerReps.push(DealerRep.toDealerRep(o2));
        }

        return dealerReps;
    }

    public static toDealerRep(obj: string | Object): DealerRep {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of DealerRep.
        let dealerRep = Object.assign(new DealerRep(), obj2);

        if (dealerRep.dealer != null) {
            dealerRep.dealer = Dealer.toDealer(dealerRep.dealer);
        }

        return dealerRep;
    }
}
